import { jsx as _jsx } from "react/jsx-runtime";
import dipyramidUrl from '../../../assets/gems/dipyramid.svg?inline';
export function Dipyramid({ ...props }) {
    return _jsx("img", { ...props, src: dipyramidUrl, alt: 'DipyramidImage' });
}
